import "babel-polyfill";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/slick/slick";
import "./libs/bodymovin";
import "./libs/custom-scrollbar/jquery.mousewheel";
import "./libs/custom-scrollbar/jquery.mCustomScrollbar";

import {binder, fwa} from "./libs/binder";
import { constants, navFunction, scroll} from "./modules/module";
import {customSelect} from "./modules/customSelect";
import {insertSvgPagination} from "./modules/insertSvgPagination";
import {animationOnScroll} from "./modules/animationOnScroll";
import {popups} from './modules/pupup';
import {customScrollbar} from './modules/customScrollbar';
import {carousel} from './modules/carousel';
import {scrollTo} from './modules/scroll-to';
import {highlightsSlider} from './modules/highlightsSlider';
import { accordion } from './modules/accordion';
import { beliefsBlock } from './modules/beliefs-block';
import { highchartsSetup } from './modules/highcharts-setup';
import { lookupForm } from './modules/lookup-form';


binder({
    bounds: {
        "html": [constants],
        ".header": navFunction,
        "select, .contact-form": customSelect,
        ".pagination": insertSvgPagination,
        ".has-animation": animationOnScroll,
        ".popup-show": popups,
        ".custom-scroll-holder": customScrollbar,
        ".carousel": carousel,
        ".scroll-to": scrollTo,
        ".highlights-slider": highlightsSlider,
        ".accordion": accordion,
        ".beliefs-block": beliefsBlock,
        ".graphics-block": highchartsSetup,
        ".lookup-form": lookupForm
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js